

import Link from 'next/link'
import React from 'react'

const FooterPage = () => {
  return (
    <div className='bg-white py-5 container mx-auto'>
        <div className='flex justify-between items-center text-[#6e8497] text-[10px]'>
            <div>
                <p>© {new Date().getFullYear()} TravelFirst Designed By InitCoders.</p>
            </div>
            <div className='flex-between w-[150px]'>
                    <Link href={"/terms"} target='_blank'>Terms Of Services</Link>
                    <Link href={"privacy-policy"} target='_blank'>Privacy Policies</Link>
            </div>
        </div>
    </div>
  )
}

export default FooterPage